module.exports = __webpack_public_path__ + "static/media/fantasma.1ea19cec.jpeg";